// --------------------------------------------------------
// src/views/book.view.js
//
// Manage the view/template of a book object
//
// --------------------------------------------------------
"use strict";

const BOOK_TEMPLATE = `
	<figure class="bookContainer" data-pdf="<%= this.model.getDefaultLink() %>" >		
		<img src="./assets/images/<%= this.model.get('img') %>"/>
		<figcaption class="caption">
		<div class="col-lg-10 col-sm-9 col-xs-9 p0">
			<h4 class="book-title m0" data-id="<%= this.model.get('id')%>"><%= this.model.formatTitle(20) %></h4>
		</div>
		<div class="clearfix"></div>
		<div class="col-lg-3 book-options">
			<a><i class="fa fa-book show-options" aria-hidden="true" data-id="<%= this.model.get('book_id')%>"></i></a>
			<a href="#<%= app.getLanguage() %>/book/<%= this.model.get('book_id')%>"><i class="fa fa-info" aria-hidden="true"></i></a>
		</div>
		</figcaption>
	</figure>
`;

// The view for a single book model
const BookComponent = Backbone.View.extend({

	// The DOM element that will be created
	tagName: "div",
	
	className: "my-20 hvr-shrink col-md-6 col-sm-6 col-xs-12 p0",

	// Will be used to the set the css width
	width: 4,

	// The event listeners and their callbacks
	events: {
		"click .show-options"	: "showOptions",
		"click img"			 	: "openPdf",
		"click h4.book-title"	: "openPdf"
	},

	// Convert the template to html
	template: _.template( BOOK_TEMPLATE ),

	initialize: function(options) {
		this.options = options || {};

		this.width = options.width || this.width;
		// The width of the element can change
		// We generally display a 4x4 grid but some templates use a different grid
		// To compute the width we divide 12 (the max grid width from Boostrap) by the number of books we want to display
		var gridWidth = 12 / this.width;
		this.className += " " + "col-lg-" + gridWidth;
		// Backbone doesn't wait for render() before assgning the default classname to the DOM element
		// We need to change it here to apply the grid width changes
		this.el.className = this.className;
	},

	// Render the template
	render: function() {

		this.$el.html(this.template(this.model));

		return this;
	},

	// Open the download dialog and offer the download options to the user
	showOptions: function() {
		var view;

		// Create the view
		view = new BookDownloadModalComponent({ model: this.model, trigger: ".show-options" });
		$(document.body).append(view.render().el);
		view.open();
	},

	// Open the PDF of a selected book
	openPdf: function() {
		var link;

		link = this.$el.find("figure.bookContainer").attr("data-pdf");
		window.open(link, "_blank");
	}
});
